<template>
  <div>
    <div class="healthy">
      <div>
        <!-- 详情 -->
        <div class="details_list">
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div style="font-size: 2vh;font-weight: 700;">ID:{{ id || '' }}
            </div>
            <div class="body-type-view__btn" @click="print" v-if="printEnabled"
                 style="background-color: #63B25D;color: white;font-size: 2vh;display: flex;align-items: center;justify-content: center">
              <img src="../../assets/images/print.png" alt="" style="height: 2vh;width: 2vh"/>
              <span style="margin-left: 5px">打印</span>
            </div>
          </div>
          <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px">
            <div style="flex: 7">
              <div class="details">
                <div class="details_item">
                  <span>姓名:</span>
                  <span>{{ username }}</span>
                </div>
                <div class="details_item pl30" style="display: none">
                  <span>所属机构:</span>
                  <span>某医疗机构</span>
                </div>
              </div>
              <div class="details pt30">
                <div class="details_item" style="flex: 0.5">
                  <span>性别:</span>
                  <span>{{ sex }}</span>
                </div>
                <div class="details_item pl30" style="flex: 1">
                  <span>出生日期:</span>
                  <span>{{ birthday }}</span>
                </div>
              </div>
              <div class="details pt30">
                <div class="details_item" style="flex: 0.5">
                  <span>年龄:</span>
                  <span>{{ age }}岁</span>
                </div>
                <div class="details_item pl30" style="flex: 1;">
                  <span>体检日期:</span>
                  <span style="flex: 1">{{ createTime }}</span>
                </div>
              </div>
            </div>
            <div style="flex: 3;flex-direction: column;align-items: center;justify-content: center"
                 class="header_title">
              <div class="total-score" style="height: 120px;width: 120px;">
                <div style="height: 95px;width: 95px;background-color: white;border-radius: 100px;
                display: flex;align-items: center;justify-content: center;font-size: 40px;font-weight: bolder">
                  {{ averageScore }}
                </div>
              </div>
              <div style="font-size: 18px;font-weight: 300;margin-top: 5px">综合健康指数</div>
            </div>
          </div>
        </div>
        <!-- 健康状况总评 -->
        <div class="comments">
          <div class="comments_title">
            <span></span>
            <span>健康状况评估</span>
          </div>
          <div class="commentsItem">
            <div class="commentsItem_list" @click="openPhy()">
              <img
                  alt=""
                  src="../../assets/images/health_status_icon1.png"
              />
              <div>生理年龄</div>
            </div>
            <div class="commentsItem_list" @click="openGl()">
              <img
                  alt=""
                  src="../../assets/images/health_status_icon2.png"
              />
              <div>舌诊检测</div>
            </div>
            <div class="commentsItem_list" @click="openPulse()">
              <img
                  alt=""
                  src="../../assets/images/health_status_icon3.png"
              />
              <div>脉诊检测</div>
            </div>
            <div class="commentsItem_list" @click="openSound()" v-if="!soundHidden">
              <img
                  alt=""
                  src="../../assets/images/health_status_icon4.png"
              />
              <div>声强检测</div>
            </div>
            <div class="commentsItem_list" @click="openHealthServices()">
              <img
                  alt=""
                  src="../../assets/images/health_status_icon5.png"
              />
              <div>健康服务</div>
            </div>
          </div>
        </div>
        <!-- 详细健康评估 -->
        <div class="comments">
          <div class="comments_title">
            <span></span>
            <span>详细健康状况评估</span>
          </div>
          <div style="color: #999999;margin: 5px 0;font-size: 14px;">
            60分以下高风险，60-75分中风险，75-90分为低分险，90分以上正常
          </div>
          <div class="health-score-card">
            <div class="title">核心脏腑系统</div>
            <div class="score-grid">
              <div class="score-item" @click="openReportA()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn1.png" alt="" class="icon"/>
                  <span class="label">心脑血管</span>
                  <span class="score">{{ bloodVessel }}分({{ getRiskLevel(bloodVessel) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :style="{ width: bloodVessel + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportB()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn2.png" alt="" class="icon"/>
                  <span class="label">肠胃</span>
                  <span class="score">{{ stomach }}分({{ getRiskLevel(stomach) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :style="{ width: stomach + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportC()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn3.png" alt="" class="icon"/>
                  <span class="label">肝胆</span>
                  <span class="score">{{ liver }}分({{ getRiskLevel(liver) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :style="{ width: liver + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportD()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn4.png" alt="" class="icon"/>
                  <span class="label">肾脏</span>
                  <span class="score">{{ kidney }}分({{ getRiskLevel(kidney) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :style="{ width: kidney + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportE()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn5.png" alt="" class="icon"/>
                  <span class="label">呼吸</span>
                  <span class="score">{{ breathing }}分({{ getRiskLevel(breathing) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress" :style="{ width: breathing + '%' }"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="health-score-card">
            <div class="title">骨骼与内分泌调控系统</div>
            <div class="score-grid">
              <div class="score-item" @click="openReportH()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn6.png" alt="" class="icon"/>
                  <span class="label">骨骼</span>
                  <span class="score yellow">{{ bones }}分({{ getRiskLevel(bones) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress yellow" :style="{ width: bones + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportF()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn7.png" alt="" class="icon"/>
                  <span class="label">内分泌</span>
                  <span class="score yellow">{{ endocrine }}分({{ getRiskLevel(endocrine) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress yellow" :style="{ width: endocrine + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReport()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn8.png" alt="" class="icon"/>
                  <span class="label">妇科男科</span>
                  <span class="score yellow">{{ gynaecology }}分({{ getRiskLevel(gynaecology) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress yellow" :style="{ width: gynaecology + '%' }"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="health-score-card">
            <div class="title">气血津液与防御系统</div>
            <div class="score-grid">
              <div class="score-item" @click="openReportG()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn9.png" alt="" class="icon"/>
                  <span class="label">免疫</span>
                  <span class="score green">{{ immune }}分({{ getRiskLevel(immune) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress green" :style="{ width: immune + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportK()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn10.png" alt="" class="icon"/>
                  <span class="label">维生素</span>
                  <span class="score green">{{ vitamin }}分({{ getRiskLevel(vitamin) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress green" :style="{ width: vitamin + '%' }"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="health-score-card">
            <div class="title">体窍系统</div>
            <div class="score-grid">
              <div class="score-item" @click="openReportJ()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn11.png" alt="" class="icon"/>
                  <span class="label">眼睛</span>
                  <span class="score blue">{{ eyes }}分({{ getRiskLevel(eyes) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress blue" :style="{ width: eyes + '%' }"></div>
                </div>
              </div>
              <div class="score-item" @click="openReportI()">
                <div class="icon-title">
                  <img src="../../assets/images/health_detail_btn12.png" alt="" class="icon"/>
                  <span class="label">皮肤</span>
                  <span class="score blue">{{ skin }}分({{ getRiskLevel(skin) }})</span>
                </div>
                <div class="progress-bar">
                  <div class="progress blue" :style="{ width: skin + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="comments">
          <div class="comments_title">
            <span></span>
            <span>气血状态</span>
          </div>
          <div style="display: flex;align-items: center;justify-content: space-around">
            <div style="flex: 1;display: flex;justify-content: center;align-items: center;">
              <yin-yang-chart is-yin :value="yinyang[0]" :width="chartWidth" :height="chartHeight"/>
            </div>
            <div style="flex: 1;display: flex;justify-content: center;align-items: center;">
              <yin-yang-chart :value="yinyang[1]" :width="chartWidth" :height="chartHeight"/>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div class="body-type-view__btn" style="width: 20%;background-color: #5098DC;color: white;font-size: 16px">
              虚亏
            </div>
            <div class="body-type-view__btn" style="width: 20%;background-color: #63B25D;color: white;font-size: 16px">
              不足
            </div>
            <div class="body-type-view__btn" style="width: 20%;background-color: #FFBE40;color: white;font-size: 16px">
              正常
            </div>
            <div class="body-type-view__btn" style="width: 20%;background-color: #DC6766;color: white;font-size: 16px">
              旺盛
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 5px">
            <div style="width: 20%;text-align: center;color: #838383;font-size: 14px">0——30</div>
            <div style="width: 20%;text-align: center;color: #838383;font-size: 14px">30——60</div>
            <div style="width: 20%;text-align: center;color: #838383;font-size: 14px">60——80</div>
            <div style="width: 20%;text-align: center;color: #838383;font-size: 14px">80——100</div>
          </div>
          <img src="../../assets/images/bloodExplain.png"
               style="color: rgb(153, 153, 153);margin-top: 5px;font-size: 16px;width: 100%;object-fit: contain"/>
        </div>
        <!-- 体质分析 -->

        <div class="body-constitution">
          <!-- 标题 -->
          <section class="section-header">
            <div class="comments_title">
              <span></span>
              <span>体质辨识</span>
            </div>
            <div class="body-type">
              <span class="title-icon common"/>
              <span class="label">体质：</span>
              <span class="type">{{ constitutionInfo.name }}</span>
              <span class="mark">（{{ constitutionInfo.syndrome }}）</span>
            </div>
          </section>

          <!-- 分割线 & 常见表现 -->
          <section class="section-common">
            <div class="divider"></div>
            <div class="subtitle-row">
              <span class="title-icon common"/>
              <span class="subtitle">常见表现：</span>
            </div>
            <div class="tags">
              <span class="tag" v-for="(item,index) in body.performance" :key="index">{{ item }}</span>
            </div>
          </section>

          <!-- 中间人体占位 -->
          <section class="section-bodymap">
            <img src="../../assets/images/body.png" style="width: 90vw;object-fit: contain">
          </section>

          <!-- 释义 -->
          <section class="section-explain">
            <div class="explain-title-row">
              <span class="title-icon explain"/>
              <span class="explain-title">释义：</span>
            </div>
            <div class="explain-text" v-html="body.reason">
            </div>
          </section>
        </div>

        <div class="meridian-analysis">
          <!-- 主标题 -->
          <div class="comments_title">
            <span></span>
            <span>中医十二经分析</span>
          </div>

          <!-- 说明文字卡片 -->
          <div class="intro-card">
            人体十二经是内联脏腑，外通肢节，运行气血，沟通内外，维持生命活动的十二条核心能量通道，
            以下为通过综合检测判断需注意的几大经络
          </div>

          <div class="meridian-reflection">
            <!-- 左侧人体 -->
            <div class="left-panel">
              <img class="human-img" :src="`./images/24/${diagnostic_results}.jpg`" alt="人体图"/>
            </div>

            <!-- 右侧比例表 -->
            <div class="right-panel">
              <div ref="chart" class="chart"></div>
            </div>
          </div>
          <div class="chart-title">· 经络反射图</div>

          <!-- 经络详情卡片列表 -->
          <div class="meridian-card" v-for="card in meridians.list" :key="card.name">
            <div class="card-left">
              <img class="img-placeholder"
                   :src="`./images/12/${card.icon}.jpg`"/>
            </div>
            <div class="card-right">
              <div class="card-title">{{ card.name }}</div>
              <div class="card-text">{{ card.description }}</div>
              <div class="card-text">
                <strong>关联脏腑：</strong><span class="highlight">{{ card.relations.join('、') }}</span>
              </div>
              <div class="card-text"><strong>异常原因：</strong>{{ card.reason }}</div>
              <div class="card-text"><strong>常见表现：</strong>{{ card.performance }}</div>
            </div>
          </div>

          <!-- 底部总结 -->
          <div class="footer-text">
            其他局部经络（{{ meridians.other.reason }}）
          </div>
          <div class="footer-note">
            本算法及数据均由孔德兴教授及浙江数理医学学会联合打造
          </div>
        </div>


        <!-- //免责声明 -->
        <div class="statement">
          <div>免责声明</div>
          <span>
                欢迎您使用个人健康评估报告（以下简称：健康报告），本人已经阅读健康报告服务条款并同意本声明。
          </span>
          <h2></h2>
          <span>
            健康报告是针对亚健康人群进行科学化数据指标采集设备，并非医疗器械设备。健康报告所有资料及数据报告仅供参考使用，不作为个人健康状况的医疗目的衡量指标，也不能替代医生和其他医务人员的专业建议。
          </span>
          <h2></h2>
          <span>
            在任何情况下，健康报告所提供数据仅为提升用户体验所用，用户对于其自身健康状况的最终评估仅来自于专业医疗机构的检测手段，健康报告对于采集数据不做任何形式的保证，不保证所提供数据满足用户的要求，对采集结果的安全性、正确性、及时性均不做保证。故本产品不对因使用本品提供的数据而导致之损失或损害承担任何直接或间接责任。
          </span>
          <h2></h2>
          <span>
            健康报告是为亚健康人群设计，相关指标依据人体数据采集系统而成，经过科学及实践测算出来，并非特别针对残缺人士及疾病患者，此类人群使用可能会出现个别指标测量不精准。
          </span>
          <h2></h2>
          <span>
            健康报告推送的内容，数据指标、运动调理、健康食谱、健康设备、调养方法等均作为个人健康管理所需的参考，不作为处方，用户可根据自身情况结合专业诊断结果进行。本产品不对通过健康报告服务得到的或在其信息平台上所推介的产品或服务做任何担保。如用户进行采纳健康报告所推送的内容所产生一切后果，本产品不承担任何责任。
            </span>
          <h2></h2>
          <span>
            健康报告是基于假定用户{result}情况下进行的数据采集，采集结果每时每刻都在发生变化，所以建议测量选择固定时间点，最好是空腹平静心态下测量会更有效。用户通过健康报告获取材料或数据由自己承担风险，同时将对使用此类材料或数据而导致的人身或财产损失承担全部责任。
            </span>
          <h2></h2>
          <span>
            因数据报告里面包含个人隐私问题，当用户分享给它人或朋友圈时，即表示该用户自行同意把隐私公开。
            </span>
          <h2></h2>
          <span>
            本产品重视对用户隐私的保护，用户提供的登记资料及本产品保留的有关若干其他个人资料将受到中国有关隐私的法律法规的保护。非经用户亲自许可或根据相关法律的强制性规定，本产品不会主动的将用户的信息泄露给其他任何第三方。
            </span>
          <h2></h2>
          <span>
            本产品有权在必要时修改服务条款，服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，用户应主动取消此项服务。如果用户继续使用服务，则视为接受服务条款的变动。
            </span>
          <h2></h2>
          <span>
            凡以任何方式登录健康报告，或对用户使用健康报告、网络平台、与本产品相关的任何内容、服务均视为自愿接受健康报告声明的约束。无论在任何原因下（包括但不限于疏忽原因），对用户或任何人通过使用健康报告所导致的损失或损害（包括直接、间接的损失或损害），责任均由使用者自行承担（除非该等损失系由本产品质量不达标所致）。
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {Toast} from 'vant'
import YinYangChart from "../../components/YingYangChart";
import {getFixedConstitutionScore} from "../../utils/yinyang";
import {splitRandomSign} from "../../utils/pulse";
import * as echarts from 'echarts'

import lungIcon from '@/assets/icons/lung.png';
import spleenIcon from '@/assets/icons/spleen.png';
import intestineIcon from '@/assets/icons/intestine.png';
import stomachIcon from '@/assets/icons/stomach.png';

const icons = [lungIcon, spleenIcon, intestineIcon, stomachIcon]
const stringSimilarity = require('string-similarity');

function findMostSimilarText(text, stringList) {
  const similarities = stringSimilarity.findBestMatch(text, stringList);
  return similarities.bestMatchIndex;
}

function parseThreePartsToTags(text) {
  // 清理文本
  const cleanText = text.trim()
      .replace(/\r\n/g, '\n')
      .replace(/\n{2,}/g, '\n');

  // 用正则提取三大段
  const reasonMatch = cleanText.match(/^(.*?)\n(?=表现：)/s);
  const performanceMatch = cleanText.match(/表现：([\s\S]*?)(?=\n中医建议：)/);
  const suggestionMatch = cleanText.match(/中医建议：([\s\S]*)$/);

  // 去掉开头类似 "释义：" 等标头
  function removeLeadLabel(str) {
    return (str || '').replace(/^(释义|表现|中医建议)[:：]\s*/, '');
  }

  // reason 自动换行
  function formatReason(str) {
    return removeLeadLabel(str)
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean)
        .join('<br/>');
  }

  // 表现 → 标签数组
  function splitToTags(str) {
    return removeLeadLabel(str)
        .split(/[、，,。；;]+/) // 用中文/英文逗号顿号句号分割
        .map(s => s.trim())
        .filter(Boolean);
  }

  return {
    reason: formatReason(reasonMatch ? reasonMatch[1].trim() : ''),
    performance: splitToTags(performanceMatch ? performanceMatch[1].trim() : ''),
    suggestion: removeLeadLabel(suggestionMatch ? suggestionMatch[1].trim() : '')
  };
}

function parseMeridianDataWithOtherAndNames(text) {
  const lines = text.trim().split(/\n+/);
  const list = [];
  let other = null;
  let current = null;

  const pushCurrent = () => {
    if (current) {
      // 拆分 firstName 和 secondName
      if (current.name.includes('/')) {
        const parts = current.name.split('/');
        current.firstName = parts[0];
        current.secondName = parts[1];
      } else {
        current.firstName = current.name;
        current.secondName = '';
      }
      if (current.firstName.includes('&')) {
        current.icon = current.firstName.substring(0, current.firstName.indexOf('&')).trim()
      } else if (current.firstName.includes('（')) {
        current.icon = current.firstName.substring(0, current.firstName.indexOf('（')).trim()
      } else if (current.firstName.includes('(')) {
        current.icon = current.firstName.substring(0, current.firstName.indexOf('(')).trim()
      } else {
        current.icon = current.firstName
      }
      list.push(current);
    }
  };

  lines.forEach(line => {
    const startMatch = line.match(/^(.+?)\s*\(≈\s*(\d+)%\)/);
    const otherMatch = line.match(/^其他局部经络/);

    if (startMatch) {
      pushCurrent();
      const match = startMatch
      current = {
        name: match[1].replace(/\s*\/\s*/g, '/').trim(),
        ratio: parseInt(match[2], 10),
        reason: '',
        performance: '',
        relations: [], description: ''
      };
      return;
    }

    if (otherMatch) {
      pushCurrent();
      current = null;
      other = {
        name: '其他局部经络',
        reason: '',
        performance: ''
      };
      return;
    }

    const reasonMatch = line.match(/^异常原因[:：](.*)$/);
    if (reasonMatch) {
      if (current) current.reason = reasonMatch[1].trim();
      else if (other) other.reason = reasonMatch[1].trim();
      return;
    }

    const perfMatch = line.match(/^常见表现[:：](.*)$/);
    if (perfMatch) {
      if (current) current.performance = perfMatch[1].trim();
      else if (other) other.performance = perfMatch[1].trim();
      return;
    }

    if (other && !other.reason) {
      other.reason = line.trim();
    }
  });

  pushCurrent();

  return {list, other};
}

/**
 * 根据经络名称匹配对应的 icon
 * @param {string} meridianName 例如 "手太阴肺经"
 * @returns {string|null} icon路径 或 null
 */
function getMeridianIcon(meridianName) {
  return null;
  if (!meridianName) return null;

  // 全转成字符串防止出错
  const name = String(meridianName);

  // 这里用包含匹配，可以适配多个别称
  if (name.includes('肺')) {
    return lungIcon;
  } else if (name.includes('脾')) {
    return spleenIcon;
  } else if (name.includes('大肠')) {
    return intestineIcon;
  } else if (name.includes('胃')) {
    return stomachIcon;
  }
  // 如果是其它特殊经络，可在这里继续扩展
  // else if (name.includes('肝')) return liverIcon;

  // 没匹配就给一个通用的 "其他" 图标，或者返回 null
  return null;
}

function getRiskLevel(score) {
  if (score < 60) {
    return "高风险";
  } else if (score < 75) {
    return "中风险";
  } else if (score < 90) {
    return "低风险";
  } else {
    return "正常";
  }
}

export default {
  name: 'Details',
  components: {YinYangChart},
  data() {
    return {
      id: null,
      alert: false,
      soundHidden: false,
      printEnabled: false,
      outId: '',
      top_image: '',
      username: '',
      age: '',
      birthday: '',
      createTime: '',
      height: '',
      weight: '',
      sex: '',
      physiologicalAge: '',
      bloodVessel: '',
      stomach: '',
      liver: '',
      kidney: '',
      breathing: '',
      endocrine: '',
      immune: '',
      bones: '',
      gynaecology: '',
      skin: '',
      eyes: '',
      vitamin: '',
      getqyinfo: '',
      grade: '',
      timerout: '',
      constitution: 0,
      constitutionText: null,
      healthyTypes: [{text: '平和体质'}, {text: '气滞体质'}, {text: '血瘀体质'}, {text: '阳虚体质'}, {text: '阴虚体质'}, {text: '气虚体质'}, {text: '血虚体质'}, {text: '痰湿体质'}, {text: '特凛体质'}],
      leftHealthyTypes: [{text: '平和体质'}, {text: '气滞体质'}, {text: '血瘀体质'}, {text: '阳虚体质'}, {text: '阴虚体质'}],
      rightHealthyTypes: [{text: '气虚体质'}, {text: '血虚体质'}, {text: '痰湿体质'}, {text: '特凛体质'}],
      yinyang: [50, 50],
      chartWidth: 200, chartHeight: 200,
      pulse: '',
      constitutionInfo: {
        name: '',
        syndrome: '',
        explain: '',
        health: '',
        meridians: ''
      },
      body: {
        reason: "异常原因是机体阴液亏少，失于滋润、濡养，导致虚热内扰。它在脏腑辨证中主要与肾、肝、肺三脏关系最为密切。\n\n肾为先天之本，元阴之根：肾阴，又称“真阴”、“元阴”，是人体阴液的根本，能濡养全身脏腑。肾阴虚会导致全身性的阴虚表现。\n\n肝藏血，肾藏精，精血同源：肝阴需肾阴的滋养。肝肾阴虚常常同时出现，导致头晕目眩、耳鸣等症。\n\n肺为娇脏，喜润恶燥：肺主清肃，性喜柔润。肺阴不足则宣降失常，导致干咳、口咽干燥。",
        performance: [
          "头晕目眩",
          "耳鸣健忘",
          "失眠多梦",
          "腰膝酸软（与阳虚的冷痛不同，多是酸软无力）",
          "胁肋隐痛",
          "男子可见遗精",
          "女子可见月经量少",
          "同时伴有五心烦热（手心、脚心、心口发热）",
          "午后潮热",
          "盗汗（夜间睡着时出汗）",
          "颧红（两颊潮红）",
          "口干咽燥"
        ],
        suggestion: "总原则是 “滋补肾阴，壮水之主，以制阳光” 。核心是滋补阴液，清降虚火。阴虚质主要对应肾、肝、肺的阴液亏虚，最常见证型是肝肾阴虚。"
      },
      meridians: {list: [], other: {}},
      cards: [
        {
          title: '手太阴肺经',
          desc: '主要分布在上肢内侧前缘，起于中焦、属肺，络大肠。其主要功能是主气、司呼吸。',
          organs: '肺、大肠',
          reason: '肺主气，司呼吸功能减弱，经气必然不足。',
          symptom: '为咳嗽无力、气短、畏风。'
        },
        {
          title: '足太阴脾经',
          desc: '主要分布在胸腹及下肢内侧前缘，起于足大趾，属脾，络胃。主要功能是运化水谷、统摄血液。',
          organs: '脾、胃',
          reason: '脾主运化，升清功能减弱，精微无法输布全身。',
          symptom: '为肌肉消瘦或虚胖，四肢乏力、腹胀。'
        },
        {
          title: '手阳明大肠经',
          desc: '主要分布在上肢外侧前缘，起于食指，属大肠，络肺。主要功能是传导糟粕、调节水液代谢。',
          organs: '肺、大肠',
          reason: '肺与大肠相表里，肺气虚易致传导失职。',
          symptom: '合谷穴处酸麻或酸胀感。'
        },
        {
          title: '足阳明胃经',
          desc: '主要分布在头面、胸腹及下肢外侧前缘，起于鼻旁，属胃，络脾。主要功能是受纳、腐熟水谷。',
          organs: '胃、脾',
          reason: '脾与胃互为表里，胃虚则纳运失常。',
          symptom: '压痛或酸胀感，三里穴常见反应。'
        }
      ],
      bars: [],
      maxBarWidth: 160, // 条形最大长度(px)
      tickCount: 10, // X 轴刻度数量
    }
  },
  computed: {
    maxRatio() {
      return Math.max(...this.bars.map(b => b.ratio));
    },
    averageScore() {
      const list = [this.bloodVessel || 100,
        this.stomach || 100,
        this.liver || 100,
        this.kidney || 100,
        this.breathing || 100,
        this.bones || 100,
        this.endocrine || 100,
        this.gynaecology || 100,
        this.immune || 100,
        this.vitamin || 100,
        this.eyes || 100,
        this.skin || 100
      ]
      const total = list.reduce((prev, cur) => Number(prev) + Number(cur), 0)
      console.error(total)
      return Math.round(total / list.length).toFixed(0)
    }
  },
  created() {
    // document.title = '健康报告'
    console.log(this.$route.query)
    this.id = this.$route.query.id
    this.alert = this.$route.query.alert
    this.soundHidden = this.$route.query.soundHidden || false
    this.printEnabled = this.$route.query.printEnabled || false
  },
  mounted() {
    let width = window.innerWidth * 0.8
    this.chartWidth = this.chartHeight = width / 2
    console.error('chartWidth', this.chartWidth)
    this.getcode(this.id)
  },
  methods: {
    getRiskLevel,
    getcode(id) {
      let url = `${this.baseUrl}/app/details?id=${id}`
      axios.post(url)
          .then((result) => {
            let user = result.data.user
            let userState = result.data.userState
            console.log(user)
            this.username = user.name
            this.createTime = user.updateTime
            this.age = userState.age
            this.outId = userState.outId
            this.birthday = userState.birthday
            this.weight = userState.weight
            this.height = userState.height
            let physiological = userState.physiologicalAge
            this.physiologicalAge = physiological.toString()
            this.bloodVessel = userState.bloodVessel
            this.stomach = userState.stomach
            this.liver = userState.liver
            this.kidney = userState.kidney
            this.breathing = userState.breathing
            this.endocrine = userState.endocrine
            this.immune = userState.immune
            this.bones = userState.bones
            this.gynaecology = userState.gynaecology
            this.skin = userState.skin
            this.eyes = userState.eyes
            this.vitamin = userState.vitamin
            this.timerout = userState.timeout
            this.constitution = userState.constitution || 0
            this.top_image = 'api/sys/common/static/' + userState.headPortrait
            if (userState.sex === 1) {
              this.sex = '男'
            } else {
              this.sex = '女'
            }
            let grades = parseInt(this.bloodVessel) + parseInt(this.stomach) + parseInt(this.liver) +
                parseInt(this.kidney) + parseInt(this.breathing) + parseInt(this.endocrine) + parseInt(this.immune) +
                parseInt(this.bones) + parseInt(this.gynaecology) + parseInt(this.skin) + parseInt(this.eyes) + parseInt(this.vitamin)

            let grades_count = grades / 12
            if (grades_count > 90) {
              this.grade = '5'
            } else if (grades_count > 85) {
              this.grade = '4'
            } else {
              this.grade = '3'
            }

            const percentages = userState.pulse.split(',')
            const pulses = splitRandomSign(percentages)
            console.error('pulses', pulses)
            const maxIndex = pulses.positiveData
                .map((v, i) => [v, pulses.negativeData[i]]) // 合并成二维数组
                .reduce(
                    (acc, pair, i) => {
                      const localMax = Math.max(Math.abs(pair[0]), Math.abs(pair[1]));
                      return localMax > acc.max ? {index: i, max: localMax} : acc;
                    },
                    {index: -1, max: -Infinity}
                ).index
            this.pulse = ['紧脉', '实脉', '弦脉', '洪脉', '滑脉'][maxIndex || 0]
            console.error('pulse', this.pulse)

            let details = result.data.userDetails

            this.bodyfluidNames = details.bodyfluidnames
            this.bodyfluidDescribe = details.bodyfluiddescribe
            this.colorOfMossNames = details.colorofmossnames
            this.colorOfMossDescribe = details.colorofmossdescribe
            this.colorOfTongueNames = details.coloroftonguenames
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.mossNames = details.mossnames
            this.mossDescribe = details.mossdescribe
            this.shapeOfTongueNames = details.shapeoftonguenames
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.veinNames = details.veinnames
            this.veinDescribe = details.veindescribe
            this.constitutionNames = details.constitutionnames

            this.constitution = findMostSimilarText(this.constitutionNames, this.healthyTypes.map(item => item.text))
            console.error('constitution', this.constitution)
            this.constitutionDescribe = details.constitutiondescribe
            this.singleConfigName = details.singleconfigname
            this.ossOriImgUrl = details.ossoriimgurl
            this.ossSplitImgUrl = details.osssplitimgurl
            this.ossSplitBackImgUrl = details.osssplitbackimgurl
            let json = JSON.parse(details.treatplanjson)
            console.log(json)
            this.diagnostic_results = json[0] && json[0].diagnostic_results || this.constitutionNames
            this.sports_health_care = json[0] && json[0].sports_health_care
            this.diet_rehabilitation = json[0] && json[0].diet_rehabilitation
            this.predisposition = json[0] && json[0].predisposition || [{message: json.predisposition}]
            this.massage_health_care = json[0] && json[0].massage_health_care
            this.main_performance = json[0] && json[0].main_performance || [{message: json.mainPerformance}]
            this.occur_reason = json[0] && json[0].occur_reason || json.occurReason && json.occurReason.map(item => {
              return {
                message: item
              }
            })
            this.drug_health_care = json[0] && json[0].drug_health_care
            this.recuperates = json[0] && json[0].recuperates
            // this.initYYChart()
            this.renderYinYang()
          }).catch(error => {
        console.error(error)
      })
    },
    openGl() {
      this.$router.push({
        path: '/Healthy/Glossoscopy',
        query: {id: this.id, showTitle: this.$route.query.showTitle}
      })
      // if (this.timerout === '90') {
      // } else {
      //   Toast('未做舌诊报告')
      // }
    },
    openPulse() {
      this.$router.push({path: '/Healthy/Pulse', query: {id: this.id, showTitle: this.$route.query.showTitle}})
      // if (this.timerout === '90') {
      //   this.$router.push({ path: '/Healthy/Pulse', query: { id: this.id, showTitle: this.$route.query.showTitle } })
      // } else {
      //   Toast('未做脉诊报告')
      // }
    },
    openSound() {
      this.$router.push({path: '/Healthy/Sound', query: {id: this.id, showTitle: this.$route.query.showTitle}})
      // if (this.timerout === '90') {
      //   this.$router.push({ path: '/Healthy/Sound', query: { id: this.id, showTitle: this.$route.query.showTitle } })
      // } else {
      //   Toast('未做声强报告')
      // }
    },
    openPhy() {
      this.$router.push({
        path: '/Healthy/PhysiologicalAge',
        query: {id: this.id, showTitle: this.$route.query.showTitle}
      })
    },
    openHealthy() {
      this.$router.push({
        path: '/Healthy/Healthymind',
        query: {id: this.id, showTitle: this.$route.query.showTitle}
      })
    },
    openHealthServices() {
      this.$router.push({
        path: '/Healthy/NewHealthServices',
        query: {id: this.id, showTitle: this.$route.query.showTitle}
      })
      // if (this.timerout === '90') {
      //   this.$router.push({ path: '/Healthy/HealthServices', query: { id: this.id, showTitle: this.$route.query.showTitle } })
      // } else {
      //   Toast('未做舌诊报告')
      // }
    },
    openReportA() {
      this.$router.push({path: '/Healthy/ReportA', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportB() {
      this.$router.push({path: '/Healthy/ReportB', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportC() {
      this.$router.push({path: '/Healthy/ReportC', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportD() {
      this.$router.push({path: '/Healthy/ReportD', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportE() {
      this.$router.push({path: '/Healthy/ReportE', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportF() {
      this.$router.push({path: '/Healthy/ReportF', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportG() {
      this.$router.push({path: '/Healthy/ReportG', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportH() {
      this.$router.push({path: '/Healthy/ReportH', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportI() {
      this.$router.push({path: '/Healthy/ReportI', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportJ() {
      this.$router.push({path: '/Healthy/ReportJ', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReportK() {
      this.$router.push({path: '/Healthy/ReportK', query: {id: this.id, showTitle: this.$route.query.showTitle}})
    },
    openReport() {
      if (this.sex === '男') {
        this.$router.push({
          path: '/Healthy/ReportNan',
          query: {id: this.id, showTitle: this.$route.query.showTitle}
        })
      } else {
        this.$router.push({path: '/Healthy/ReportNv', query: {id: this.id, showTitle: this.$route.query.showTitle}})
      }
    },
    gotoConstitution(index) {
      if (this.alert && this.constitution == index) {
        // alert(index)
      }
    },
    initYYChart() {
      var chartDom = document.getElementById('yychart');
      const echarts = this.$echarts
      var myChart = echarts.init(chartDom);

      const option = {
        xAxis: {show: false, min: 0, max: 100},
        yAxis: {show: false, min: 0, max: 100},
        grid: {top: 0, bottom: 0, left: 0, right: 0},
        series: [
          {
            type: 'custom',
            renderItem: function (params, api) {
              const w = api.getWidth(), h = api.getHeight();
              const cx = w / 2, cy = h / 2, r = Math.min(w, h) / 2;

              return {
                type: 'path',
                shape: {
                  pathData: `M${cx},0
                  C${cx - r},${cy / 2}, ${cx - r},${cy * 1.5}, ${cx},${h}
                  C${cx + r},${cy * 1.5}, ${cx + r},${cy / 2}, ${cx},0 Z`
                },
                style: {fill: '#e26666'}
              };
            }
          },
          {
            type: 'custom',
            renderItem: function (params, api) {
              const w = api.getWidth(), h = api.getHeight();
              const cx = w / 2, cy = h / 2, r = Math.min(w, h) / 2;

              return {
                type: 'path',
                shape: {
                  pathData: `M${cx},0
                  C${cx + r},${cy / 2}, ${cx + r},${cy * 1.5}, ${cx},${h}
                  C${cx - r},${cy * 1.5}, ${cx - r},${cy / 2}, ${cx},0 Z`
                },
                style: {fill: '#3d84d5'}
              };
            }
          },
          {
            type: 'custom',
            renderItem: function (params, api) {
              const cx = api.getWidth() / 2;
              const cy = api.getHeight() / 2;
              return {
                type: 'text',
                style: {
                  text: '阳',
                  x: cx + 40,
                  y: cy,
                  textAlign: 'center',
                  textVerticalAlign: 'middle',
                  font: 'bold 20px sans-serif',
                  fill: '#fff'
                }
              };
            }
          },
          {
            type: 'custom',
            renderItem: function (params, api) {
              const cx = api.getWidth() / 2;
              const cy = api.getHeight() / 2;
              return {
                type: 'text',
                style: {
                  text: '阴',
                  x: cx - 40,
                  y: cy,
                  textAlign: 'center',
                  textVerticalAlign: 'middle',
                  font: 'bold 20px sans-serif',
                  fill: '#fff'
                }
              };
            }
          }
        ]
      }

      myChart.setOption(option);
    },
    renderYinYang() {
      const result = getFixedConstitutionScore(this.id, this.diagnostic_results)
      if (result) {
        this.yinyang = [result.yin, result.yang]
        console.error('yinyang', this.yinyang)
      }
      this.getConstitution(this.diagnostic_results)
    },
    print() {
      // this.baseUrl = 'http://localhost:9547'
      let url = `${this.baseUrl}/app/generate_print/${this.id}`
      axios.post(url, {
        yinyang: this.yinyang,
        constitution: this.healthyTypes[this.constitution].text,
        predisposition: this.predisposition && this.predisposition.map(item => item.message).join('\n'),
        mainPerformance: this.main_performance && this.main_performance.map(item => item.message).join('\n'),
        occurReason: this.occur_reason && this.occur_reason.map(item => item.message).join('\n'),
        pulse: this.pulse
      })
          .then((result) => {
            console.error(result)
            if (result && result.data) {
              if (window.AndroidInterface && AndroidInterface.onResultReady) {
                console.error('invoke window.AndroidInterface')
                const data = JSON.stringify(result.data);
                console.error(data)
                AndroidInterface.onResultReady(data);
              }
            }
          })
    },
    getConstitution(name) {
      console.error(this)
      this.$http.getConstitution(name).then(({data}) => {
        console.error('getConstitution', data)

        this.constitutionInfo = {...this.constitutionInfo, ...data}
        // 最终解析输出

        this.body = parseThreePartsToTags(data.explain)
        console.error(this.body)

        this.meridians = parseMeridianDataWithOtherAndNames(data.meridians)
        console.error(this.meridians)
        this.meridians.list = this.meridians.list || []
        let i = 0
        for (let item of this.meridians.list) {
          this.bars.push({...item, icon: getMeridianIcon(item.name)})
          this.getMeridian(item)
        }
        this.bars.push({name: '其它次级经络', ratio: 5})
        setTimeout(() => {
          this.drawChart()
        }, 1000)
      })
    },
    getMeridian(item) {
      if (item.firstName) {
        this.$http.getMeridian(item.firstName).then(({data}) => {
          console.error('getMeridian', data)
          if (data == null) {
            return
          }
          var relations = data.relation.split('、')
          for (let relation of relations) {
            if (item.relations.includes(relation)) {
              continue
            }
            item.relations.push(relation)
          }
          if (item.description == '') {
            item.description = data.description
          }
        })
      }

      if (item.secondName) {
        this.$http.getMeridian(item.secondName).then(({data}) => {
          console.error('getMeridian', data)
          if (data == null) {
            return
          }
          var relations = data.relation.split('、')
          for (let relation of relations) {
            if (item.relations.includes(relation)) {
              continue
            }
            item.relations.push(relation)
          }
          if (item.description == '') {
            item.description = data.description
          }
        })
      }
    },
    drawChart() {
      const chart = echarts.init(this.$refs.chart);
      const maxVal = Math.max(...this.bars.map(b => b.ratio));
      const barH = 28;

      // y轴数据：顶部加一个空占位
      const yData = ['', ...this.bars.map(b => b.name)];

      // 图标数据：第0个是占位（无图标）
      const iconData = [
        {value: 0, symbol: 'none'},
        ...this.bars.map(b => ({
          value: b.ratio,
          symbol: b.icon ? 'image://' + b.icon : 'none'
        }))
      ];

      // 柱子数据：第0个占位 value=0
      const barData = [0, ...this.bars.map(b => b.ratio)];

      chart.setOption({
        grid: {
          left: 0,
          right: 20,
          top: 10,
          bottom: 10,
          containLabel: false
        },
        xAxis: {
          type: 'value',
          max: maxVal * 2,
          position: 'bottom',
          axisLine: {
            show: true,
            symbol: ['none', 'arrow'],
            lineStyle: {color: '#000', width: 1}
          },
          axisTick: {show: true, length: 5},
          axisLabel: {show: false},
          splitLine: {show: false}
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: yData,
          axisLine: {
            show: true,
            symbol: ['none', 'arrow'], // y轴箭头
            symbolSize: [8, 10],
            lineStyle: {color: '#000', width: 1}
          },
          axisTick: {show: false},
          axisLabel: {show: false}
        },
        series: [
          // 图标系列
          {
            type: 'pictorialBar',
            symbolPosition: 'start',
            symbolOffset: [12, 0],
            symbolSize: [20, 20],
            z: 3,
            data: iconData,
            tooltip: {show: false}
          },
          // 柱状系列
          {
            type: 'bar',
            barWidth: barH,
            data: barData,
            // barCategoryGap: '80%',  // 调大数值 → 间距更大，调小 → 更紧凑
            // barGap: '100%',        // pictorialBar 与 bar 完全重叠
            label: {
              show: true,
              position: 'right',
              formatter: (p) => {
                // 第一行是占位，不显示文字
                if (p.dataIndex === 0) return '';
                const idx = p.dataIndex - 1;
                return `${p.value}%   ${this.bars[idx].name}`;
              },
              color: '#333',
              fontSize: 14,
              fontWeight: 'normal',
              padding: [0, 0, 0, 8]
            },
            itemStyle: {
              color: (p) => {
                // 占位行透明
                if (p.dataIndex === 0) return 'transparent';
                const colors = ['#004a99', '#0072ce', '#33aaff', '#66ccff', '#bce6f7'];
                return colors[p.dataIndex - 1];
              },
              borderRadius: 4
            },
            z: 2
          }
        ]
      });
    }
  }
}
</script>

<style scoped>
.statement {
  padding-top: 50px;
  padding-left: 1vw;
  padding-right: 1vw;
}

.statement > div:nth-child(1) {
  font-size: 35px;
  color: #ffffff;
  font-weight: 650;
  padding-bottom: 30px;
}

.statement > span {
  color: #ffffff;
  line-height: 50px;
}

.col9 {
  color: #999999 !important;
  font-size: 0.4rem;
}

.assessmentText {
  color: rgba(215, 100, 35, 1) !important;
  font-weight: 700 !important;
  font-size: 26px;
  padding: 20px 0;
}

.assessment > img {
  width: 75px;
  height: 75px;
  display: block;
}

.assessment {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commentsItem_list {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commentsItem_list > img {
  width: 88px;
  height: 88px;
  display: block;
}

.commentsItem_list > div {
  margin-top: 20px;
  font-size: 0.4rem;
  color: #000000;
  font-weight: 650;
}

.commentsItem {
  display: flex;
  justify-content: space-between;
}

/* .commentsItem{width: 25%;} */
.comments_title {
  display: flex;
  align-items: center;
}

.comments_title > span:nth-child(1) {
  width: 1.2vh;
  height: 1.2vh;
  background: #dc6666;
  border-radius: 50%;
  display: block;
  margin-right: 15px;
}

.comments_title > span:nth-child(2) {
  font-size: 0.4rem;
  color: #000000;
  font-weight: 700;
}

/deep/ .van-nav-bar .van-icon {
  color: black !important;
}

.pl30 {
  /*padding-left: 50px;*/
}

.pt30 {
  padding-top: 50px;
}

.header_title {
  background-color: #ffffff;
  width: 20vw;
  height: 20vw;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.healthy {
  /* background: url(https://img.js.design/assets/img/6330750235a21bf1cb3e9f31.png#84e217802a762075630feb094c1b1025); */
  background: #e9c7a0;
  width: 100%;
  /* height: 100vh; */
  padding: 1rem 0 0.4rem 0;
  /* background-size: 100% 100% !important; */
}

.header {
  background-color: #ffffff;
  border-radius: 25px 25px 0 0;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header > div:nth-child(2) {
  font-size: 32px;
  font-weight: 700;
  color: #000000;
  margin-top: 20px;
}

.header_title > img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

.details_list {
  background-color: #ffffff;
  border-radius: 25px;
  padding: 20px 45px 45px 45px;
}

.details {
  display: flex;
  justify-content: space-between;
}

.details_item {
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.details_item > span:nth-child(1) {
  font-size: 1.5vh;
  color: #000000;
}

.details_item > span:nth-child(2n) {
  color: #999999;
  font-size: 1.5vh;
  margin-left: 5px;
  font-weight: 700;
}

.comments {
  margin-top: 30px;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 45px 30px;
}

.health-score-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.health-score-card {
  background-color: #ffffff;
  border-radius: 12px; /* 圆角边 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 四周阴影 */
  padding: 20px;
  margin: 16px 0;
  transition: box-shadow 0.3s ease; /* 可选：添加 hover 动效 */
}

.health-score-card .title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 24px;
  color: #666;
}

.health-score-card .score-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.health-score-card .score-item {
  width: calc(50% - 12px);
}

.health-score-card .score-item:nth-child(even) {
  padding-left: 24px;
}

.health-score-card .icon-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.health-score-card .icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.health-score-card .label {
  flex: 1;
  margin-left: 10px;
  color: #333;
  font-size: 26px;
}

.health-score-card .score {
  color: #DC6766;
  font-size: 20px;
  font-weight: bold;
}

.health-score-card .progress-bar {
  width: 100%;
  height: 12px;
  background-color: #ddd;
  border-radius: 999px;
  overflow: hidden;
}

.health-score-card .progress {
  height: 100%;
  background-color: #DC6766;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.health-score-card .yellow {
  color: #FFA800;
}

.health-score-card .green {
  color: #63B25D;
}

.health-score-card .blue {
  color: #1576D0;
}

.health-score-card .progress.yellow {
  background-color: #FFA800;
}

.health-score-card .progress.green {
  background-color: #63B25D;
}

.health-score-card .progress.blue {
  background-color: #1576D0;
}

.total-score {
  background-image: url("../../assets/images/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-type-view {
  display: flex;
  justify-content: center;
  align-items: stretch; /* 拉伸高度 */
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);
  height: 600px; /* 设置一个固定高度或父级撑开的高度 */
}

.body-type-view__side {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 关键点：按钮均匀分布撑满高度 */
  flex: 1;
  max-width: 120px; /* 控制按钮区宽度 */
}

.body-type-view__btn {
  background: #fff;
  padding: 10px 16px;
  border-radius: 16px;
  font-size: 20px;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.body-type-view__btn--active {
  background-color: #c95858;
  color: #fff;
  box-shadow: none;
}

.body-type-view__center {
  margin: 0 40px;
  height: 540px; /* 设置一个固定高度或父级撑开的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-type-view__human {
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}

</style>
<style lang="less" scoped>
.body-constitution {
  background-color: #fff;
  margin-top: 30px;
  border-radius: 30px;
  padding: 45px 30px;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #333;

  .title-icon {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
    background-color: #d84a4a; // 默认红
    &.common {
      background-color: #f0a500; // 常见表现用黄色
    }

    &.explain {
      background-color: #f07b00; // 释义用橘色
    }
  }

  .section-title {
    font-size: 26px;
    font-weight: 700;
    color: #2d2d2d;
  }

  .body-type {
    font-size: 24px;
    margin-top: 10px;

    .label {
      color: #333;
    }

    .type {
      color: #555;
    }

    .mark {
      color: #e74c3c;
    }
  }

  .section-common {
    margin-top: 14px;

    .divider {
      height: 1px;
      background-color: #eee;
      margin-bottom: 8px;
    }

    .subtitle-row {
      display: flex;
      align-items: center;
    }

    .subtitle {
      font-size: 24px;
      font-weight: 700;
      margin-top: 10px;
      color: #2d2d2d;
    }

    .tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;

      .tag {
        display: inline-block;
        padding: 4px 10px;
        background-color: #fff4e5;
        border-radius: 12px;
        font-size: 24px;
        color: #a45f1b;
        font-weight: 700;
        border: 1px solid #f5d9b8;
      }
    }
  }

  .section-bodymap {
    margin-top: 20px;
    display: flex;
    justify-content: center;

    .placeholder {
      width: 240px;
      height: 300px;
      border: 1px dashed #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #aaa;
    }
  }

  .section-explain {
    margin-top: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 12px;
    font-size: 23px;
    line-height: 1.6;

    .explain-title-row {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
    }

    .explain-title {
      color: #e74c3c;
      font-weight: 700;
      font-size: 24px;
    }

    .explain-text {
      color: #444;
    }
  }
}
</style>
<style lang="less" scoped>
.meridian-analysis {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  background: #fff;
  color: #333;
  margin-top: 30px;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 45px 30px;

  .main-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .title-dot {
      width: 8px;
      height: 8px;
      background: #d84a4a;
      border-radius: 50%;
      margin-right: 6px;
    }

    .main-title {
      font-weight: 700;
      font-size: 28px;
      color: #2d2d2d;
    }
  }

  .intro-card {
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 12px;
    font-size: 24px;
    line-height: 1.6;
    margin-bottom: 16px;
  }

  .meridian-card {
    display: flex;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    padding: 12px;
    margin-bottom: 16px;

    .card-left {
      flex: 4;
      display: flex;
      align-items: center;

      .img-placeholder {
        width: 100%;
        border: 1px dashed #ccc;
        background-color: #f5f5f5;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        object-fit: contain;
        color: #999;
      }
    }

    .card-right {
      flex: 6;
      padding-left: 12px;

      .card-title {
        font-weight: 700;
        font-size: 25px;
        color: #0066cc;
        margin-bottom: 6px;
      }

      .card-text {
        font-size: 23px;
        color: #555;
        margin-bottom: 4px;
        line-height: 1.4;
      }

      .highlight {
        color: #e74c3c;
        font-weight: 700;
      }
    }
  }

  .footer-text {
    font-size: 24px;
    color: #d84a4a;
    font-weight: 700;
    text-align: center;
    margin-bottom: 8px;
  }

  .footer-note {
    font-size: 22px;
    color: #888;
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
.meridian-reflection {
  display: flex;
  align-items: center;
  justify-content: center;
  //height: 300px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;

  .left-panel {
    display: flex;
    justify-content: center;
    align-items: center;

    .human-img {
      height: 500px;
      object-fit: contain;
    }
  }

  .right-panel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .chart {
      width: 420px;
      height: 480px;
    }
  }
}

.chart-title {
  //margin-top: 4px;
  width: 100%;
  font-size: 32px;
  color: #555;
  display: flex;
  justify-content: center;
}
</style>
